<template>
  <div class="header-brand-tagline" aria-hidden="true">
    <span class="header-brand-tagline__line">{{ $t('header_brand_tagline_line1') }}</span>
    <span class="header-brand-tagline__line">{{ $t('header_brand_tagline_line2') }}</span>
  </div>
</template>

<script>
export default {
  name: 'HeaderBrandTagline',
};
</script>

<style lang="scss" scoped>
.header-brand-tagline {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
}

.header-brand-tagline__line {
  display: block;
  white-space: nowrap;
}

@media (min-width: 900px) {
  .header-brand-tagline {
    font-size: 14px;
  }
}

@media (max-width: 899px) {
  .header-brand-tagline {
    font-size: 11px;
    margin-left: 6px;
  }
}
</style>
